window.onload = function(){
    var html = document.getElementsByTagName("html")[0];
    var width = document.body.clientWidth || document.documentElement.clientWidth;
    var rem;
    if(width/1600*10>20){
        rem = 20 + "px";
    }else if(width/1600*10 < 12){
        rem = 12 + "px";
    }else{
        rem = width/1600*10 + "px"
    }
}

window.onresize = function(){
    var html = document.getElementsByTagName("html")[0];
    var width = document.body.clientWidth || document.documentElement.clientWidth;
    var rem;
    if(width/1600*10>20){
        rem = 20 + "px";
    }else if(width/1600*10 < 12){
        rem = 12 + "px";
    }else{
        rem = width/1600*10 + "px"
    }
}


// WEBPACK FOOTER //
// ./src/rem.js